import Cookies from "js-cookie";
// 主域名
const indextoken = "logintoken";
export function getToken() {
  return Cookies.get(indextoken);
}
export function setToken(username) {
  return Cookies.set(indextoken, username, {
    expires: 1,
    path: "/",
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141", "192.168.110.67"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}
export function removeToken() {
  return Cookies.remove(indextoken, {
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141", "192.168.110.67"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}
// 设置跳转
const Openurl = "href";
export function getUrl() {
  return Cookies.get(Openurl);
}
export function setUrl(username) {
  return Cookies.set(Openurl, username, {
    expires: 1,
    path: "/",
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141",
      "192.168.110.67",
      "192.168.110.191"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}
export function removeUrl() {
  return Cookies.remove(Openurl, {
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141",
      "192.168.110.67"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}
// 设置手机号
const Phone = "phonenum";
export function getphonenum() {
  return Cookies.get(Phone);
}
export function setphonenum(username) {
  return Cookies.set(Phone, username, {
    expires: 1,
    path: "/",
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141",
      "192.168.110.67"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}
export function removephonenum() {
  return Cookies.remove(Phone, {
    domain: [
      "localhost",
      "127.0.0.1",
      "192.168.2.31",
      "192.168.2.112",
      "192.168.110.141",
      "192.168.110.67"
    ].includes(document.domain)
      ? document.domain
      : ".zhuoyuyun.com"
  });
}



// WEBPACK FOOTER //
// ./src/common/cook.js